import { render, staticRenderFns } from "./Fullimage.vue?vue&type=template&id=d0abd276&scoped=true&"
import script from "./Fullimage.vue?vue&type=script&lang=js&"
export * from "./Fullimage.vue?vue&type=script&lang=js&"
import style0 from "./Fullimage.vue?vue&type=style&index=0&id=d0abd276&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0abd276",
  null
  
)

export default component.exports